<template>
    <div class="cargo_seach">
        <div class="row">
            <div class="col-sm-auto">
                <div class="date_content">
                    <div class="row">
                        <div class="col">
                            <div class="date_box">
                                <datepicker :format="format" placeholder="請選擇起始日期" class="beforeImg" @input="$emit('update:startDate', $event)"></datepicker>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-1 row">
                                <p>一</p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="date_box">
                                <datepicker :format="format" placeholder="請選擇結束日期" class="afterImg" @input="$emit('update:endDate', $event)"></datepicker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <b-nav-form>
                    <b-form-input :value="keyword" @input="$emit('update:keyword', $event)" size="sm" class="store_input" type="text" placeholder="請輸入關鍵字" required />
                    <b-button size="sm" class="login_search" type="button" @click="$emit('search')"></b-button>
                </b-nav-form>
            </div>
            <div class="col-sm-auto">
                <div class="pay_method">
                    <b-dropdown id="ddown1" :text="payMethodText" @click="console.log('click')">
                        <b-dropdown-item :value="''" @click="selectdrop('')">
                            <input name="payMethod" type="radio" id="zero" value="">
                            全選
                        </b-dropdown-item>
                        <b-dropdown-item :value="'3'" @click="selectdrop(3)">
                            <input name="payMethod" type="radio" id="one" value="3">
                            線上刷卡
                        </b-dropdown-item>
                        <b-dropdown-item :value="'4'" @click="selectdrop(4)">
                            <input name="payMethod" type="radio" id="two" value="4">
                            ATM轉帳
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker'
    import _ from 'lodash'

    export default {
        props: {
            startDate: {
                type: Date,
                // required:true,
            },
            endDate: {
                type: Date,
            },
            format: {
                type: String,
                default() {
                    return 'yyyy-MM-dd'
                },
            },
            keyword: {
                type: String,
            },
            payMethod: {
                type: [Number, String]                                                                                                                                         ,
            },
        },
        data() {
            return {
                payMethodList: {
                    '': '全選',
                    3: '線上刷卡',
                    4: 'ATM轉帳',
                },
            }
        },
        name:'cargoseach',
        components:{
            Datepicker,
        },
        computed: {
            payMethodText() {
                return _.get(this.payMethodList, this.payMethod)
            },
        },
        methods: {
            selectdrop(value) {
                this.$emit('update:payMethod', value);
            }
        }
        
    }
</script>
